import { useEffect } from "react";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

export interface LiquidateAllFormValues {
  cancelOrders: boolean;
}

export const liquidateAllFormSchema = z.object({
  cancelOrders: z.boolean(),
});

export interface UseLiquidateAllControllerArgs {
  /** Re-seeds the checkbox each time the confirmation is opened. */
  active: boolean;
  onConfirm: (values: LiquidateAllFormValues) => void;
}

export interface LiquidateAllController {
  cancelOrders: boolean;
  setCancelOrders: (next: boolean) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

export const useLiquidateAllController = ({
  active,
  onConfirm,
}: UseLiquidateAllControllerArgs): LiquidateAllController => {
  const { handleSubmit, reset, setValue, watch } =
    useForm<LiquidateAllFormValues>({
      resolver: zodResolver(liquidateAllFormSchema),
      defaultValues: { cancelOrders: false },
    });

  // biome-ignore lint/correctness/useExhaustiveDependencies: `active` is the trigger — leaving and re-entering the confirmation discards the previous choice. The body writes rather than reads it.
  useEffect(() => {
    reset({ cancelOrders: false });
  }, [active, reset]);

  return {
    cancelOrders: watch("cancelOrders"),
    setCancelOrders: (next) => setValue("cancelOrders", next),
    onSubmit: handleSubmit(onConfirm),
  };
};
